import { jsx } from "slate-hyperscript";
import { inlineStyleToObject, styleToSlateMarkAttributes } from "../functions";
export const htmlDeserializer = (el, markAttributes = {}) => {
    var _a;
    if (el.nodeType !== Node.ELEMENT_NODE && el.nodeType !== Node.TEXT_NODE) {
        return null;
    }
    if (el.nodeType === Node.TEXT_NODE) {
        const text = el.textContent;
        if (text === null)
            return null;
        const trimedText = text.trim();
        if (trimedText.length === 0)
            return null;
        const replaceLineBreakToSpace = text.replace(/\n/g, " ");
        return jsx("text", markAttributes, replaceLineBreakToSpace);
    }
    const inlineStyle = el.getAttribute("style");
    const inlineStyleAsObject = inlineStyleToObject(inlineStyle !== null && inlineStyle !== void 0 ? inlineStyle : "");
    const style = styleToSlateMarkAttributes(inlineStyleAsObject);
    const nodeAttributes = Object.assign(Object.assign({}, markAttributes), style);
    // define attributes for text nodes
    switch (el.nodeName) {
        case "strong":
            nodeAttributes.bold = true;
    }
    const children = (_a = Array.from(el.childNodes)
        .map((node) => htmlDeserializer(node, nodeAttributes))
        .reduce((prev, curr) => {
        if (curr === null)
            return prev;
        if (!Array.isArray(prev))
            return [];
        if (!Array.isArray(curr)) {
            return [...prev, curr];
        }
        return [...prev, ...curr];
    }, [])) !== null && _a !== void 0 ? _a : [];
    if (children.length === 0) {
        const acceptedEmptyParentNodes = ["P", "BR"];
        if (!acceptedEmptyParentNodes.includes(el.nodeName))
            return null;
        children.push(jsx("text", nodeAttributes, ""));
    }
    switch (el.nodeName) {
        case "BODY":
            return jsx("fragment", {}, children);
        case "BLOCKQUOTE":
            return jsx("element", Object.assign({ type: "paragraph" }, nodeAttributes), children);
        case "P":
            return jsx("element", Object.assign({ type: "paragraph" }, nodeAttributes), children);
        case "BR":
            return jsx("element", Object.assign({ type: "paragraph" }, nodeAttributes), children);
        default:
            return children;
    }
};
